(function (app, ng) {

    app.provider("supportEmailer",
        [
            function () {
                this.$get = [
                    "$mdDialog", function ($mdDialog) {
                        var service = {};

                        service.open = function (options) {
                            return $mdDialog.show({
                                targetEvent: options.event,
                                templateUrl: "/App/Services/SupportEmailer/template.html",
                                resolve: {
                                    actingUser: [
                                        "userApi", function (userApi) {
                                            return userApi.getContextUserIds().then(function (userContext) {
                                                return userApi.get(userContext.ActingUserId);
                                            });
                                        }]
                                },
                                locals: {
                                    options: options
                                },
                                controller: supportEmailerController,
                                controllerAs: "$ctrl"
                            });
                        }
                        return service;
                    }
                ];
            }
        ]);

    supportEmailerController.$inject = ["$mdDialog", "options", "emailApi", "actingUser", "$filter"];
    function supportEmailerController($mdDialog, options, emailApi, actingUser, $filter) {
        var $ctrl = this;        
        ng.extend($ctrl,
            {
                ui: {
                    FullName: actingUser.FirstName + " " + actingUser.LastName,
                    EmailAddress: actingUser.Email,
                    PhoneNumber: actingUser.PhoneNumber ? $filter("tel")(actingUser.PhoneNumber.Value) : null,
                    Submitting: false
            },
                close: close,
                submitTicket: submitTicket              
        });


        function close() { return $mdDialog.hide(); }

        function submitTicket($event) {
            $ctrl.ui.Submitting = true;
            var d = new Date();
            var time = d.toLocaleTimeString();
            var date = d.toLocaleDateString();
            var year = d.getFullYear();
            var phoneNumber = $ctrl.ui.PhoneNumber || "No number given";

            var body = "<html>" +
                "<head>" +
                "<meta charset='utf-8'>" +
                "<title>iComply Support Message</title>" +
                "</head>" +
                "<body>" +
                "<table width='80%' align='center' cellpadding='0' cellspacing='0'>" +
                "<tr>" +
                "<td height='80'><span style='display:block; font-size: 25px;' />iComply Support Request</span><br></td>" +
                "</tr>" +
                "<tr>" +
                "<td style='border:#ddd 1px solid;'></td>" +
                "</tr>" +
                "<tr>" +
                "<td style='padding:20px 20px; font-family:Arial, Helvetica, sans-serif; color:#5B5B5B ; line-height:18px;'>" +
                "<p>The following support request was submitted via iComply at " +
                time +
                " on " +
                date +
                "</p>" +
                "<p><strong>Full Name:</strong> " +
                $ctrl.ui.FullName +
                "</p>" +
                "<p><strong>Email: </strong> " +
                $ctrl.ui.EmailAddress +
                "</p>" +
                "<p><strong>Phone: </strong> " +
                phoneNumber +
                "</p>" +
                "<p><strong>Message: </strong> " +
                $ctrl.ui.Body +
                "</p>" +
                "</td>" +
                "</tr>" +
                "<tr>" +
                "<td style='border:#ddd 1px solid;'></td>" +
                "</tr>" +
                "<tr>" +
                "<td height='30' align='center' style='font-family:Arial, Helvetica, sans-serif; font-size:10px; color:#5B5B5B ;'>" +
                "Copyright &copy; " +
                year +
                "  All Rights Reserved. <a href='http://www.figmarketing.com'><font color='#5B5B5B '>Financial Independence Group, Inc.</font></font></a>" +
                "</td>" +
                "</tr>" +
                "</table>" +
                "</body>" +
                "</html>";

            var email = {
                Subject: "iComply Support Request - " + $ctrl.ui.FullName,
                Body: body,
                Recipients: { 
                    "0": ["helpdesk@figmarketing.com"],
                    "2": ["devteam@figmarketing.com"]
                },          
                SenderId: actingUser.Id
            };

            emailApi.createAndSend(email, $event).then(function () {
                submit($event);
            }, function (err) {
                error($event);
                $ctrl.ui.Submitting = false;
            });
        }

        function submit($event) {

            var leave = $mdDialog.alert({
                title: "Your request has been submitted. Thank you.",
                targetEvent: $event,
                ariaLabel: "Support request submitted",
                ok: "Continue",
                skipHide: true,
                clickOutsideToClose: false
            });
            $ctrl.ui.Submitting = false;                   
            $mdDialog.show(leave).then(function () {                                 
            }).finally(function () {
                $mdDialog.hide($event);
            });

        }

        function error($event) {
            var errorAlert = $mdDialog.alert({
                title: "There was an error processing your request.  Please contact your sales associate for assistance.",
                targetEvent: $event,
                ariaLabel: "Support request error",
                ok: "Ok",
                skipHide: true,
                clickOutsideToClose: false
            });
            $ctrl.ui.Submitting = false;
            $mdDialog.show(errorAlert).then(function() {
               
            });
        }
    };

})(window.app, window.angular); //jshint ignore:line